import api from '@/libs/axios'
import { addOrUpdateInList, cleanEntityToSend } from '../../utils/form'
import Vue from 'vue'
import ToastificationContent from '@/components/toastification/ToastificationContent.vue'
import { capitalize } from '@/utils/filter'
import i18n from '@/libs/i18n'
import store from '../index'
import useAppConfig from '../../utils/useAppConfig'
import useAPI from '../../utils/useAPI'
import qs from 'qs'
import { clone } from '../../utils/utils'
import router from '../../router'

export default {
  // Payload : page, perPage, searchCriteria, sortColumn, sortOrder
  getOffers ({ commit, state }, payload) {
    // const { performApiCall } = useAPI()
    store.commit('app/TOGGLE_LOADING', true)

    return new Promise((resolve, reject) => {
      // console.log(payload)
      api.get('/offers2' + '?' + qs.stringify(payload))
        .then(response => {
          commit('SET_OFFERS', response.data.results)
          commit('SET_OFFERSCONTEXT', response.data.page_context)
          store.commit('app/TOGGLE_LOADING', false)

          resolve(response.data)
        })
        .catch(err => {
          console.log('Error', err)
          // reject(err)
        })
    })

    // return new Promise((resolve, reject) => {
    //   let url = '/offers2'
    //
    //   performApiCall(url, payload)
    //     .then(response => {
    //       commit('SET_OFFERS', response.results)
    //       commit('SET_OFFERSCONTEXT', response.page_context)
    //       store.commit('app/TOGGLE_LOADING', false)
    //       resolve(true)
    //     })
    //
    // })

  },
  getOffer ({ commit, state }, offerId) {
    store.commit('app/ADD_LOADER')

    return new Promise((resolve, reject) => {
      api.get('/offers/' + offerId)
        .then(response => {
          addOrUpdateInList(response.data, state.offers, 'offer', commit)

          store.commit('app/REMOVE_LOADER')
          resolve(response.data)

        })
        .catch(err => {
          console.log('Error', err)
          reject(err)
        })
    })
  },
  async addOffer ({ commit, state }, offer) {
    return await cleanEntityToSend(offer, state.params)
      .then(async clonedEntityToSend => {
        return new Promise((resolve, reject) => {
          api.post('/offers', clonedEntityToSend)
            .then(response => {
              commit('ADD_OFFER', response.data)
              commit('UPDATE_OFFERSTOTALRESULT', true)

              Vue.$toast({
                component: ToastificationContent,
                props: {
                  title: capitalize(i18n.t('success')),
                  icon: 'check',
                  text: i18n.t('The offer has been ', { crud: i18n.t('createdE') }),
                  variant: 'success'
                },
              })

              if (
                router.history.current.name == 'WorkFlo view' &&
                clone(store.getters['workFlo/getWorkFloHistory']) != { comingSoon: [], history: [] }
              ) {
                store.dispatch('workFlo/getWorkFloHistory', store.getters['workFlo/getCurrentWorkFlo'].id)
              }

              resolve(response)
            })
            .catch(error => {
              console.log('Error', error)
              reject(error)
            })
        })

      })
      .catch(error => {
        console.log('Error', error)
        reject(error)
      })
  },
  async updateOffer ({ commit, state }, offer) {
    // console.log(offer)
    return await cleanEntityToSend(offer, state.params)
      .then(async clonedEntityToSend => {

        // console.log(clonedEntityToSend)

        return new Promise((resolve, reject) => {
          api.put('/offers/' + offer.id, clonedEntityToSend)
            .then(response => {
              commit('UPDATE_OFFER', response.data)

              Vue.$toast({
                component: ToastificationContent,
                props: {
                  title: capitalize(i18n.t('success')),
                  icon: 'check',
                  text: i18n.t('The incoming invoice has been ', { crud: i18n.t('editedE') }),
                  variant: 'success'
                },
              })

              if (
                router.history.current.name == 'WorkFlo view' &&
                clone(store.getters['workFlo/getWorkFloHistory']) != { comingSoon: [], history: [] }
              ) {
                store.dispatch('workFlo/getWorkFloHistory', store.getters['workFlo/getCurrentWorkFlo'].id)
              }

              resolve(response)
              // resolve(JSON.parse(JSON.stringify(response)))
            })
            .catch(error => {
              console.log('Error', error)
              reject(error)
            })
        })

      })
      .catch(error => {
        console.log('Error', error)
        reject(error)
      })
  },
  removeOffer ({ commit }, offer) {
    return new Promise((resolve, reject) => {
      api.delete('/offers/' + offer.id)
        .then(response => {
          commit('REMOVE_OFFER', offer)
          commit('UPDATE_OFFERSTOTALRESULT', false)

          Vue.$toast({
            component: ToastificationContent,
            props: {
              title: capitalize(i18n.t('success')),
              icon: 'check',
              text: i18n.t('The incoming invoice has been ', { crud: i18n.t('removedE') }),
              variant: 'success'
            },
          })

          if (
            router.history.current.name == 'WorkFlo view' &&
            clone(store.getters['workFlo/getWorkFloHistory']) != { comingSoon: [], history: [] }
          ) {
            store.dispatch('workFlo/getWorkFloHistory', store.getters['workFlo/getCurrentWorkFlo'].id)
          }

          resolve(response)
        })
        .catch(error => {
          console.log('Error', error)
          reject(error)
        })
    })
  },
  async transformProductsToOutgoingInvoice ({ commit, state }, payload) {
    let offer = payload.offer
    offer.toInvoice = ''
    payload.selectedProducts.forEach(sp => {
      let quantity = (typeof sp._selectedQuantity !== 'undefined') ? sp._selectedQuantity : sp.quantity

      if (offer.toInvoice == '') {
        offer.toInvoice = '{"productId":' + sp.id + ',"quantity":' + quantity + '}'
      } else {
        offer.toInvoice += '@{"productId":' + sp.id + ',"quantity":' + quantity + '}'
      }
    })

    return await cleanEntityToSend(offer, state.params)
      .then(async clonedEntityToSend => {
        return new Promise((resolve, reject) => {
          api.put('/offers/' + offer.id + '/transformToOutgoingInvoice', clonedEntityToSend)
            .then(response => {
              offer = response.data.offer
              payload.selectedProducts.forEach(p => p.outgoingInvoice = response.data.outgoingInvoice)

              offer._linkedOutgoingInvoices.push(response.data.outgoingInvoice)
              let hasRemaining = false
              response.data.outgoingInvoice.products.forEach(op => {
                let ofp = offer.products.findIndex(p => p.id == op.parent.id)
                offer.products[ofp]._remaining = offer.products[ofp]._remaining - op.quantity
                if (offer.products[ofp]._remaining != 0) {
                  hasRemaining = true
                }
              })

              if (!hasRemaining) {
                offer._status = 'Fully invoiced'
              }

              commit('UPDATE_OFFER', offer)
              store.commit('outgoingInvoice2/ADD_OUTGOINGINVOICE', response.data.outgoingInvoice)
              store.commit('outgoingInvoice2/UPDATE_OUTGOINGINVOICESTOTALRESULT', true)

              Vue.$toast({
                component: ToastificationContent,
                props: {
                  title: capitalize(i18n.t('success')),
                  icon: 'check',
                  text: i18n.t('The outgoingInvoice has been ', { crud: i18n.t('createdE') }),
                  variant: 'success'
                },
              })

              if (
                router.history.current.name == 'WorkFlo view' &&
                clone(store.getters['workFlo/getWorkFloHistory']) != { comingSoon: [], history: [] }
              ) {
                store.dispatch('workFlo/getWorkFloHistory', store.getters['workFlo/getCurrentWorkFlo'].id)
              }

              resolve(response)
            })
            .catch(error => {
              console.log('Error', error)
              reject(error)
            })
        })

      })
      .catch(error => {
        console.log('Error', error)
        reject(error)
      })
  },

}